/**
 * Created by moran on 6/7/17.
 */
export const EASY_SCHEDULING = 'EASY_SCHEDULING';
export const CLEAN_AND_COMFY = 'CLEAN_AND_COMFY';
export const FRIENDLY_STAFF = 'FRIENDLY_STAFF';
export const SHORT_WAIT_TIME = 'SHORT_WAIT_TIME';
